import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=5843f96a&"
import script from "./Location.vue?vue&type=script&lang=ts&"
export * from "./Location.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports